import { render, staticRenderFns } from "./realtime.vue?vue&type=template&id=447a93f4&"
import script from "./realtime.vue?vue&type=script&lang=js&"
export * from "./realtime.vue?vue&type=script&lang=js&"
import style0 from "./realtime.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports